<ng-container *saFeatureFlag="'sandiLiteDisableAutoDispatch'">
  <div
    class="frac-home-lohi-auto-dispatch-toggle"
    *saAccountType="['lmo']; withPermissions: ['can_toggle_lohi_autodispatch']"
  >
    <sa-lmo-frac-home-card localStorageKey="home__lohi_auto_dispatch_toggle" *ngIf="isLohiAwardedOrOverflow$ | async">
      <header class="my-1 py-2">
        <img src="/assets/icons/sandi-wave.svg" alt="SANDi" /><span>Lohi Auto-Assignment</span>
      </header>
      <main>
        <section class="info-panel">
          <div>
            <mat-slide-toggle
              [checked]="enabled$ | async"
              (change)="toggleStateChanged($event)"
              [disabled]="isLoading$ | async"
              color="primary"
            >
              <ng-container *ngIf="enabled$ | async; else disabled">
                <p class="state-message">
                  Auto-Assignment is currently <span style="color: forestgreen;">ENABLED</span> for LoHi &amp; 5F
                  drivers
                </p>
              </ng-container>
              <ng-template #disabled>
                <p class="state-message">
                  Auto-Assignment is currently <span style="color: red;">DISABLED</span> for LoHi &amp; 5F drivers
                </p>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div *ngIf="hasHistory$.value">
            <p>
              Last toggled by {{ lastToggledBy$.value }} on {{ lastToggledDate$.value }} at {{ lastToggledTime$.value }}
            </p>
          </div>
        </section>
      </main>
    </sa-lmo-frac-home-card>
  </div>
</ng-container>
